module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "overlay"
  }, [_h('div', {
    staticClass: "overlay-content"
  }, [_h('a', {
    staticClass: "overlay-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": back
    }
  }, ["✕"]), " ", _m(0)])])
}},staticRenderFns: [function (){with(this) {
  return _h('div', {
    staticClass: "overlay-inner"
  }, [_h('h2', ["Smart Energy Systems"]), " ", _h('p', ["Energy systems will become smart to meet the requirement of a stable electricity supply even when the energy\n        sources, such as wind- and solar power, are highly volatile. This will enable a 100% electricity supply by\n        ", _h('span', {
    staticClass: "versa"
  }, ["RENEWABLE ENERGIES"]), " for most countries in the world. Furthermore smart energy\n        systems are needed to make the overall system more ", _h('span', {
    staticClass: "versa"
  }, ["EFFICIENT"]), " in order to reduce use\n        of resources and capital.\n        To achieve this, smart devices are necessary to interconnect renewable energies with the grid operation and\n        ", _h('span', {
    staticClass: "versa"
  }, ["SMART CONSUMERS"]), ". Smart consumers will be especially large ", _h('span', {
    staticClass: "versa"
  }, ["INDUSTRIAL"]), " or ", _h('span', {
    staticClass: "versa"
  }, ["COMMERCIAL"]), " facilities, ", _h('span', {
    staticClass: "versa"
  }, ["ELECTRIC VEHICLES"]), " and other types\n        of ", _h('span', {
    staticClass: "versa"
  }, ["STORAGE"]), " [Not the so called smart meter for end customers]. The matching of\n        supply and demand for energy will happen automatically and will not involve a change of usage patterns for\n        end customers. Thereby it also constitutes the first complete application case of the ", _h('span', {
    staticClass: "versa"
  }, ["Digitalization"]), "\n        of a whole industry.\n      "]), " ", _h('p', ["To foster the introduction of ", _h('span', {
    staticClass: "versa"
  }, ["SMART ENERGY SYSTEMS"]), " we provide consulting solutions\n        for the following\n        areas:"]), " ", _h('ul', [_h('li', ["Industrial Micro Smart Grids – Renewable, reliable and sustainable onsite generation"]), " ", _h('li', ["Economic optimization of industrial energy consumption"]), " ", _h('li', ["Energy management solutions"]), " ", _h('li', ["Future energy system and market design for 100% renewables"])]), " ", _h('h2', ["Smart Energy project activity"]), " ", _h('ul', {
    staticClass: "years"
  }, [_h('li', [_h('span', ["2015"]), "Organization of ", _h('a', {
    attrs: {
      "href": "//www.eitdigital.eu/sec2015/",
      "target": "_blank"
    }
  }, ["Smart Energy Community\n          Conference"])]), " ", _h('li', [_h('span', ["2014-2015"]), "Development of a decentralized energy supply strategy for a large industrial\n          consumer in the context of the “Energiewende” (Industrial Micro Smart Grids) – incl. flexible energy\n          management platform for multiple use cases\n        "]), " ", _h('li', [_h('span', ["2014"]), "Co-founder of ", _h('a', {
    attrs: {
      "href": "//www.eitdigital.eu/innovation-entrepreneurship/smart-energy-systems/smart-energy-community-2014/",
      "target": "_blank"
    }
  }, ["Smart\n          Energy Community Conference"])]), " ", _h('li', [_h('span', ["2013"]), "Project lead of ", _h('a', {
    attrs: {
      "href": "//www.youtube.com/watch?v=-HesDRfiiKo",
      "target": "_blank"
    }
  }, ["“Speicherstudie”"]), " -\n          a project to connect large uninterruptable power supply systems of a telecommunication provider to the\n          frequency control of a large utility\n        "]), " ", _h('li', [_h('span', ["2012"]), "Development of the pan European business area ", _h('a', {
    attrs: {
      "href": "//www.eitdigital.eu/innovation-entrepreneurship/smart-energy-systems/",
      "target": "_blank"
    }
  }, ["Smart Energy\n          Systems"]), " for EIT Digital\n          together with the leading European research institutes, universities and industry actors\n        "]), " ", _h('li', [_h('span', ["2010"]), "Smart Metering & Smart Grid in Germany – Technology Roadmap until 2020"])]), " ", _h('p', {
    staticClass: "end"
  })])
}}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-063c8424!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Smart.vue
// module id = 34
// module chunks = 1